
export interface ProductCategory {
  id: string;
  name: string;
  description: string;
  icon: string;
  productCount: number;
}

export const productCategories: ProductCategory[] = [
  {
    id: 'bpo-contact-centre',
    name: 'BPO & Contact Centre',
    description: 'AI-powered contact centre and BPO operations solutions',
    icon: '📞',
    productCount: 24
  },
  {
    id: 'agriculture-farming',
    name: 'Agriculture & Farming',
    description: 'Agricultural management and farming solutions',
    icon: '🌾',
    productCount: 6
  },
  {
    id: 'ai-machine-learning',
    name: 'AI & Machine Learning',
    description: 'Artificial intelligence and machine learning solutions',
    icon: '🤖',
    productCount: 10
  },
  {
    id: 'business-applications',
    name: 'Business Applications',
    description: 'Core business application solutions',
    icon: '💼',
    productCount: 7
  },
  {
    id: 'core-applications',
    name: 'Core Applications',
    description: 'Essential business applications and foundational tools',
    icon: '🚀',
    productCount: 14
  },
  {
    id: 'creative-media',
    name: 'Creative & Media',
    description: 'Creative design and media production tools',
    icon: '🎨',
    productCount: 5
  },
  {
    id: 'custom-development',
    name: 'Custom Development',
    description: 'Bespoke software development and consulting services',
    icon: '🛠️',
    productCount: 10
  },
  {
    id: 'customer-success-crm',
    name: 'Customer Success & CRM',
    description: 'Customer relationship and success management solutions',
    icon: '🤝',
    productCount: 10
  },
  {
    id: 'data-analytics-bi',
    name: 'Data Analytics & BI',
    description: 'Advanced analytics and business intelligence platforms',
    icon: '📊',
    productCount: 10
  },
  {
    id: 'developer-tools',
    name: 'Developer Tools',
    description: 'Development infrastructure and productivity tools',
    icon: '⚡',
    productCount: 10
  },
  {
    id: 'education-training',
    name: 'Education & Training',
    description: 'Learning management and educational platforms',
    icon: '🎓',
    productCount: 15
  },
  {
    id: 'emerging-technologies',
    name: 'Emerging Technologies',
    description: 'Cutting-edge and innovative technology solutions',
    icon: '🚀',
    productCount: 10
  },
  {
    id: 'entertainment-media',
    name: 'Entertainment & Media',
    description: 'Entertainment and media management solutions',
    icon: '🎬',
    productCount: 6
  },
  {
    id: 'facilities-management',
    name: 'Facilities Management',
    description: 'Facility and property management solutions',
    icon: '🏢',
    productCount: 7
  },
  {
    id: 'financial-business-intelligence',
    name: 'Financial & Business Intelligence',
    description: 'Financial management and business intelligence tools',
    icon: '💰',
    productCount: 21
  },
  {
    id: 'health-beauty',
    name: 'Health & Beauty',
    description: 'Health, wellness, beauty, and personal care solutions',
    icon: '💄',
    productCount: 33
  },
  {
    id: 'healthcare-medicine',
    name: 'Healthcare & Medicine',
    description: 'Medical and healthcare management systems',
    icon: '🏥',
    productCount: 7
  },
  {
    id: 'hospitality-travel',
    name: 'Hospitality & Travel',
    description: 'Hospitality management and travel service solutions',
    icon: '🏨',
    productCount: 11
  },
  {
    id: 'human-resources',
    name: 'Human Resources',
    description: 'Human resources and employee management systems',
    icon: '👥',
    productCount: 23
  },
  {
    id: 'industry-verticals',
    name: 'Industry Verticals',
    description: 'Specialized solutions for specific industries',
    icon: '🏭',
    productCount: 11
  },
  {
    id: 'intelligence-analytics',
    name: 'Intelligence & Analytics',
    description: 'Data analysis and business intelligence solutions',
    icon: '📊',
    productCount: 10
  },
  {
    id: 'legal-compliance',
    name: 'Legal & Compliance',
    description: 'Legal management and regulatory compliance solutions',
    icon: '⚖️',
    productCount: 16
  },
  {
    id: 'manufacturing-industrial',
    name: 'Manufacturing & Industrial',
    description: 'Manufacturing and industrial operations solutions',
    icon: '🏭',
    productCount: 8
  },
  {
    id: 'marketing-sales',
    name: 'Marketing & Sales',
    description: 'Marketing automation and sales optimisation tools',
    icon: '📈',
    productCount: 20
  },
  {
    id: 'mobile-development',
    name: 'Mobile Development',
    description: 'Native and cross-platform mobile application development',
    icon: '📱',
    productCount: 2
  },
  {
    id: 'operations-logistics',
    name: 'Operations & Logistics',
    description: 'Operational efficiency and logistics management',
    icon: '📦',
    productCount: 15
  },
  {
    id: 'productivity-collaboration',
    name: 'Productivity & Collaboration',
    description: 'Team productivity and collaboration platforms',
    icon: '🤝',
    productCount: 29
  },
  {
    id: 'real-estate-property',
    name: 'Real Estate & Property',
    description: 'Real estate and property management solutions',
    icon: '🏠',
    productCount: 6
  },
  {
    id: 'recruitment',
    name: 'Recruitment',
    description: 'Recruitment and talent acquisition solutions',
    icon: '👔',
    productCount: 3
  },
  {
    id: 'retail-fashion',
    name: 'Retail & Fashion',
    description: 'Retail management and fashion industry solutions',
    icon: '👗',
    productCount: 6
  }
];
